var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mydetail-wrap"},[(_vm.tabMenu==='gift')?_c('award-detail-gift'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }